const state = {
  state: {
    list:[],
    detail:[],
    options:[],
    searches:[],
    count:0,

  },
}
export default{
  state,
}



// WEBPACK FOOTER //
// ./src/store/modules/customer.js